import React from "react";
import "./ProgressBar.scss";

const ProgressBar = ({
  progress = 0,
  color = "#4F39F6",
  height = "6px",
  fillStyle,
}) => {
  const safeProgress = Math.min(Math.max(progress, 0), 100); // Clamp 0–100
  const displayProgress = safeProgress === 0 ? 2 : safeProgress; // visible sliver when 0%
  const useZeroClass = safeProgress === 0 && !fillStyle;
  const fillInlineStyle = fillStyle
    ? { width: `${displayProgress}%`, ...fillStyle }
    : { width: `${displayProgress}%`, backgroundColor: color };

  return (
    <div className="progress-bar">
      <div className="progress-bar__header">
        <div className="progress-bar__header-left">Progress</div>
        <div className="progress-bar__header-right">{safeProgress}%</div>
      </div>
      <div className="progress-bar__track" style={{ height }}>
        <div className={`progress-bar__fill ${useZeroClass ? "zero" : ""}`} style={fillInlineStyle}></div>
      </div>
    </div>
  );
};

export default ProgressBar;
